import { ISchedule, IScheduleEntry } from "@app-types/websocket/schedule.types";
import { ISuggestion, IScheduleChange, ICreateSuggestion } from '@app-types/websocket/suggestion.types';
import { SUGGESTION_CHANGE_TYPES, SUGGESTION_TYPES } from '@constants/suggestionTypes';
import { createArrayCopyAndSort } from '@components/calendar2/editPane/editActions/ScheduleCalc';

export const wrapAsNew = (newSuggestion:ICreateSuggestion, creator:number, schedule?:ISchedule) => {
    const suggestion:ISuggestion = 
    {
        id: 0,
        creatorId: creator,
        status: SUGGESTION_TYPES.UNDER_CREATION,
        changes: newSuggestion.changes,
        publishTime: 0,
        responseTime: 0,
        responseAccountId: 0,
        schedules: (schedule?[schedule.id]:[]),
    };
    return suggestion;
};

export const generateSuggestions
: (scheduleOriginal:ISchedule|undefined , scheduleNew:ISchedule|undefined) => ICreateSuggestion 
= (scheduleOriginal:ISchedule|undefined , scheduleNew:ISchedule|undefined) => {
   
    if (scheduleOriginal === undefined || scheduleNew === undefined) {
        return {changes: []};
    }

    const changesA:IScheduleChange[] = calcDiff(scheduleNew.id, scheduleOriginal.data.scheduleEntriesParentA, 
        scheduleNew.data.scheduleEntriesParentA, true);
    const changesB:IScheduleChange[] = calcDiff(scheduleNew.id, scheduleOriginal.data.scheduleEntriesParentB, 
        scheduleNew.data.scheduleEntriesParentB, false);

    const changes:IScheduleChange[] = changesA.concat(changesB);
    if (childrenChanged(scheduleOriginal.data.children, scheduleNew.data.children)) {
        changes.push({
            scheduleId:scheduleNew.id,
            type:SUGGESTION_CHANGE_TYPES.CHANGE_CHILDREN,
            children:[...scheduleNew.data.children],
            isParentA:false,
        });
    }

    const newSuggestion:ICreateSuggestion = {
        changes
    };
    return newSuggestion;
};

// order of the children does not matter, only which children the schedule is for
export const childrenChanged = (childrenOriginal:number[], childrenNew:number[]):boolean => {
    if (childrenOriginal.length !== childrenNew.length) {
        return true;
    }
    return childrenNew.some((child) => !childrenOriginal.includes(child));
};

const calcDiff 
    : (scheduleId:number, scheduleEntriesOriginal:{ [key:number]:IScheduleEntry; }, 
        scheduleEntriesNew:{ [key:number]:IScheduleEntry; }, parentA:boolean) => IScheduleChange[]
    = (scheduleId:number, scheduleEntriesOriginal:{ [key:number]:IScheduleEntry; }, 
        scheduleEntriesNew:{ [key:number]:IScheduleEntry; }, parentA:boolean) => {
   
    const newEntries = createArrayCopyAndSort(scheduleEntriesNew);
    const oldEntries = createArrayCopyAndSort(scheduleEntriesOriginal);

    let oldEntryIndex:number = 0;
    const oldEntryIdsUsed:number[] = [];

    const changes:IScheduleChange[] = [];

    for (const newEntry of newEntries) {
        if (oldEntryIndex >= 0 && oldEntries.length > oldEntryIndex) {
            while(oldEntries[oldEntryIndex].startTime < newEntry.startTime 
                && oldEntries[oldEntryIndex].endTime < newEntry.endTime) {
                if (oldEntries.length > (oldEntryIndex + 1)) {
                    oldEntryIndex++;
                } else {
                    oldEntryIndex = -1; // completed oldEntries
                    break;
                }
            }
        }

        const oldEntry:IScheduleEntry|undefined = oldEntryIndex >= 0 &&  oldEntries.length > oldEntryIndex?oldEntries[oldEntryIndex]:undefined;

        if (oldEntry) {
            if (oldEntry.startTime === newEntry.startTime
                || oldEntry.endTime === newEntry.endTime) { // lets use this old entry (as is or modified)
                oldEntryIndex+=1;
                if (oldEntries.length === oldEntryIndex) {
                    oldEntryIndex = -1;
                }
                oldEntryIdsUsed.push(oldEntry.id);
                if (oldEntry.startTime !== newEntry.startTime // we need to modify the old entry
                    || oldEntry.startAtSchool !== newEntry.startAtSchool
                    || oldEntry.startLoc !== newEntry.startLoc
                    || oldEntry.endTime !== newEntry.endTime
                    || oldEntry.endAtSchool !== newEntry.endAtSchool
                    || oldEntry.endLoc !== newEntry.endLoc) {
                        changes.push({
                            scheduleId,
                            type:SUGGESTION_CHANGE_TYPES.UPDATE_SCHEDULE_ENTRY,
                            newScheduleEntry:{...newEntry, id:oldEntry.id},
                            oldScheduleEntry:oldEntry,
                            isParentA:parentA,
                        });     
                } else { // we can use the entry as is.
                    // 
                }
            } else { // we cant use the old Entry
                changes.push({
                    scheduleId,
                    type:SUGGESTION_CHANGE_TYPES.ADD_SCHEDULE_ENTRY,
                    newScheduleEntry:newEntry,
                    isParentA:parentA,
                });
            }
        } else {
            changes.push({
                scheduleId,
                type:SUGGESTION_CHANGE_TYPES.ADD_SCHEDULE_ENTRY,
                newScheduleEntry:newEntry,
                isParentA:parentA,
            });
        }
    }
    for (const oldEntry of oldEntries) {
        if (!oldEntryIdsUsed.includes(oldEntry.id)) {
            changes.push({
                scheduleId,
                type:SUGGESTION_CHANGE_TYPES.REMOVE_SCHEDULE_ENTRY,
                oldScheduleEntry:oldEntry,
                isParentA:parentA,
            });
        }
    }


    return changes;
};




// WEBPACK FOOTER //
// ./src/helpers/calendar/suggestionCalculator.ts